import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    pageIndex: 1,
    pageSize: 25,
    searchTerm: "",
  },
  hasNextPage: true,
  loading: false,
  firstLoad: true,
  codes: {
    items: [],
    pageNumber: 0,
    totalPages: 0,
    totalCount: 0,
  },
};
export const gestioneCodeSlice = createSlice({
  name: "GestioneCodeSlice",
  initialState: initialState,
  reducers: {
    setSearchTermCode: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        searchTerm: action.payload,
      });
    },
    setCodes: (state: any, action: any) => {
      state.codes = action.payload;
    },
    addCodes: (state: any, action: any) => {
      state.codes.items = [...state.codes.items, ...action.payload];
    },
    setPageCodes: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload,
      });
    },
    resetCodesState() {
      return initialState;
    },
    setHasNextPageCodes: (state, action) => {
      state.hasNextPage = action.payload;
    },
    nextPageCodes: (state) => {
      state.filters.pageIndex++;
    },
    setLoadingCodes: (state, action) => {
      state.loading = action.payload;
    },
    setFirstLoadCodes: (state, action) => {
      state.firstLoad = action.payload;
    },
  },
});

export const {
  setSearchTermCode,
  addCodes,
  resetCodesState,
  setCodes,
  setPageCodes,
  setHasNextPageCodes,
  nextPageCodes,
  setLoadingCodes,
  setFirstLoadCodes,
} = gestioneCodeSlice.actions;

export default gestioneCodeSlice.reducer;
